import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import jquery from "jquery";

export var languageStore = defineStore('languages',() =>
{
    var languages = ref([]);

    var usedLanguages = ref([]);

    var isInDraft = ref(false);

    var targetLanguage = ref("Select");

    var scores = ref({
        total:0,
        reading:0,
        writing:0,
        speaking:0,
        listening:0,
        grammar:0
    });

    function expandRequest(index,req){
        languages.value.forEach(lang => lang.expanded = false);
        if(req) 
        {
            languages.value[index].expanded = true;
            usedLanguages.value = [];
            languages.value.forEach((lang,i) => {
                if(i != index) usedLanguages.value.push(lang.name);
            });
            isInDraft.value = true;
        }

        else
        {
            usedLanguages.value.push(languages.value[index].name);
            isInDraft.value = false;
        }
    }

    function saveLanguage(index,name,writing,reading,speaking,listening,grammar){
        languages.value[index].grammar = grammar;
        languages.value[index].listening = listening;
        languages.value[index].name = name;
        languages.value[index].reading = reading;
        languages.value[index].speaking = speaking;
        languages.value[index].writing = writing;
        languages.value[index].expanded = false;
        languages.value[index].draft = false;
        isInDraft.value = false;
        usedLanguages.value.push(name);
    }

    function removeLanguage(index){
        languages.value.splice(index,1);
        isInDraft.value = false;
    }

    function addLanguage(){
        languages.value.push(
            {
                name:'Select',
                writing:1,
                reading:1,
                speaking:1,
                listening:1,
                grammar:1,
                expanded:true,
                draft:true
            }
        )
        isInDraft.value = true;
    }

    function resetSearch(){
        languages.value = [];
        usedLanguages.value = [];
        isInDraft.value = false;
    }

    async function GetResults(toLang) 
    {
        var sameLang = false;

        if(!isInDraft.value)
        {
            targetLanguage.value = toLang;
            let resultJson = ref("");
            languages.value.forEach(lang => lang.expanded = false);
            axios.post('https://language-engine-backend.onrender.com/api/proximity/query',{
                fromLanguages:usedLanguages.value,
                toLanguage:toLang
            }).then(function (response) {
                resultJson.value = response.request.response;
                let resultArr = jquery.parseJSON(resultJson.value);

                let currentReading = 1,currentWriting = 1,currentSpeaking = 1,currentListening = 1,currentGrammar = 1;
                //let weights = [],weight = 0;

                resultArr.forEach((rel) => {
                    if(rel.From != rel.To)
                    {
                        const curr = languages.value.find(obj => obj.name == rel.From)

                        currentReading += parseFloat(rel.Reading) * curr.reading * (((rel.Grammar*curr.grammar*30)+(rel.Speaking*curr.speaking*20)+(rel.Listening*curr.listening*20)+(rel.Reading*curr.reading*15)+(rel.Writing*curr.writing*15))/100);
                        currentWriting += parseFloat(rel.Writing) * curr.writing * (((rel.Grammar*curr.grammar*30)+(rel.Speaking*curr.speaking*20)+(rel.Listening*curr.listening*20)+(rel.Reading*curr.reading*15)+(rel.Writing*curr.writing*15))/100);
                        currentSpeaking += parseFloat(rel.Speaking) * curr.speaking * (((rel.Grammar*curr.grammar*30)+(rel.Speaking*curr.speaking*20)+(rel.Listening*curr.listening*20)+(rel.Reading*curr.reading*15)+(rel.Writing*curr.writing*15))/100);
                        currentListening += parseFloat(rel.Listening) * curr.listening  * (((rel.Grammar*curr.grammar*30)+(rel.Speaking*curr.speaking*20)+(rel.Listening*curr.listening*20)+(rel.Reading*curr.reading*15)+(rel.Writing*curr.writing*15))/100);
                        currentGrammar += parseFloat(rel.Grammar) * curr.grammar * (((rel.Grammar*curr.grammar*30)+(rel.Speaking*curr.speaking*20)+(rel.Listening*curr.listening*20)+(rel.Reading*curr.reading*15)+(rel.Writing*curr.writing*15))/100);
                        //weights.push(((rel.Grammar*curr.grammar*30)+(rel.Speaking*curr.speaking*20)+(rel.Listening*curr.listening*20)+(rel.Reading*curr.reading*15)+(rel.Writing*curr.writing*15))/100);
                    }

                    else
                    {
                        scores.value.reading = -1;
                        scores.value.writing = -1;
                        scores.value.speaking = -1;
                        scores.value.listening = -1;
                        scores.value.grammar = -1;
                        scores.value.total = -1;
                        sameLang = true;
                        return;
                    }
                });

                if(!sameLang)
                {
                    scores.value.reading = Math.log10(currentReading).toFixed(4);
                    scores.value.writing = Math.log10(currentWriting).toFixed(4);
                    scores.value.speaking = Math.log10(currentSpeaking).toFixed(4);
                    scores.value.listening = Math.log10(currentListening).toFixed(4);
                    scores.value.grammar = Math.log10(currentGrammar).toFixed(4);

                    //weights = [...weights].sort((a,b) => a-b).reverse();
                    //weight = weights[0];
                

                    scores.value.total = ((Number(scores.value.reading)+Number(scores.value.writing)+Number(scores.value.speaking)+Number(scores.value.listening)+Number(scores.value.grammar))/5).toFixed(4);
                }
                
            });
            
        }
        
    }

    return {
        languages,
        usedLanguages,
        isInDraft,
        scores,
        targetLanguage,
        expandRequest,
        saveLanguage,
        removeLanguage,
        addLanguage,
        resetSearch,
        GetResults
    }
});